import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { compose, setDisplayName } from 'recompose';
import { Col, Row } from 'reactstrap';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Add from '@material-ui/icons/Add';

import immutableToJS from 'helpers/immutableToJS';
import { formatPrice } from 'helpers/utils';
import {
  injectIntl,
  SmartDialog,
} from 'components';

const getStateFromInfo = info => ({
  packrows: info.packrows,
});

class PlaceOrderDialog extends Component {
  static contextTypes = {
    setHotNotification: PropTypes.func,
  };

  static propTypes = {
    addItem: PropTypes.func.isRequired,
    info: PropTypes.shape({
      availableQuantity: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
      ]),
    }),
    formatMessage: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    invoice: PropTypes.shape({
      delivery_date: PropTypes.string,
    }).isRequired,
  };

  static defaultProps = {
    info: {},
  };

  state = getStateFromInfo(this.props.info);

  componentWillReceiveProps({ info }) {
    this.setState(getStateFromInfo(info));
  }

  render() {
    const {
      addItem,
      info,
      invoice,
      formatMessage,
      onRequestClose,
      open,
    } = this.props;
    const { setHotNotification } = this.context;
    const actions = (
      <div className="actions">
        <Button
          onClick={onRequestClose}
          variant="text"
        >
          {formatMessage('Cancel')}
        </Button>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          onClick={onRequestClose}
        >
          <Add />
          {formatMessage('Cart')}
        </Button>
      </div>
    );
    if (!open) return null;
    return (
      <SmartDialog
        maxHeight={500}
        onClose={onRequestClose}
        open={open}
      >
        <form
          className="smart-form"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <Row className="content">
            <Col xs="12" sm="12">
              <Row>
                <Col xs="11">
                  <Row>
                    <div className="header">
                      <div className="product-name">
                        {info.productData.name}
                      </div>
                      <div className="product-sub-name">
                        {info.productData.subname}
                      </div>
                    </div>
                  </Row>
                </Col>
              </Row>
              <br />
              {
                info.packrows.map((item, index) => (
                  <Row key={index}>
                    <Col xs="11">
                      <Row>
                        <Col xs="4">
                          <div className="order-dialog-qty">
                            <TextField
                              autoComplete="off"
                              defaultValue={!isEmpty(invoice.items) ?
                                (invoice.items[item.totalIndex] ?
                                invoice.items[item.totalIndex].qty : 0) : 0}
                              fullWidth
                              inputProps={{ step: 'any' }}
                              name="qty"
                              onChange={function onChange(event) {
                                event.preventDefault();
                                const { target: { value } } = event;
                                if (parseFloat(value || 0) <= parseFloat(item.availableQuantity)) {
                                  addItem(item.totalIndex, {
                                    ...info,
                                    ...info.productData,
                                    ...item,
                                    qty: parseFloat(value, 10),
                                  });
                                } else if (value) {
                                  setHotNotification(`${formatMessage('Only available')} ${item.availableQuantity} items`);
                                }
                              }}
                              placeholder="0"
                              style={{
                                marginTop: -10,
                                maxWidth: 50,
                              }}
                              type="number"
                            />
                            <div>
                              <span className="red">
                                {Math.floor(parseFloat(item.availableQuantity))}&nbsp;
                              </span>
                              <span className="italic bold black">
                                {formatMessage('left')}
                              </span>
                            </div>
                          </div>
                        </Col>
                        <Col xs="4">
                          <span>{`${item.count} ${item.uom} ${item.pack}`}</span>
                        </Col>
                        <Col xs="4">
                          <span className="highlight black">{`$${formatPrice(((item.price * (100 - (item.discount || 0))) / 100))}`}</span>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                ))
              }
              <div className="bottom-panel-order-grid">
                {actions}
              </div>
            </Col>
          </Row>
        </form>
      </SmartDialog>
    );
  }
}

/* istanbul ignore next */
const mapStateToProps = (/* state */) => ({
});

export default compose(
  setDisplayName('PlaceOrderDialog'),
  connect(
    mapStateToProps,
  ),
  immutableToJS,
  injectIntl,
)(PlaceOrderDialog);
